import { Plugin } from "prosemirror-state";
import { ReplaceStep, ReplaceAroundStep } from "prosemirror-transform";
import { getDocContentSize } from "../../core/helpers";
export function createMaxLengthPlugin(maxLength) {
    return new Plugin({
        filterTransaction: (tr, state) => {
            if (!maxLength)
                return true;
            const cur = getDocContentSize(state);
            const next = getDocContentSize({ ...state, doc: tr.doc });
            if (cur >= maxLength) {
                // allow everything that doesn't increase, or paste (which we'll insert in handlePaste)
                const isPaste = tr.getMeta("paste") ||
                    tr.getMeta("uiEvent") === "paste" ||
                    tr.getMeta("clipboardInput");
                if (next <= cur || isPaste)
                    return true;
                return (tr.steps.length === 0 ||
                    tr.steps.every((s) => (s instanceof ReplaceStep || s instanceof ReplaceAroundStep) &&
                        s.slice.content.size === 0));
            }
            return true;
        },
        props: {
            handlePaste(view, _event, slice) {
                if (!maxLength)
                    return false;
                const { state, state: { selection, schema }, } = view;
                const docLen = getDocContentSize(state);
                // length of selected text
                const selLen = selection.empty
                    ? 0
                    : selection
                        .content()
                        .content.textBetween(0, selection.content().content.size, undefined, "\n").length;
                const remaining = maxLength - (docLen - selLen);
                if (remaining <= 0)
                    return true; // block paste, no space
                const pastedText = slice.content.textBetween(0, slice.content.size, undefined, "\n");
                const cutText = pastedText.slice(0, remaining);
                // if it fits fully — return as is
                if (cutText.length === pastedText.length)
                    return false;
                // otherwise insert exactly as much as fits
                const tr = state.tr
                    .replaceSelectionWith(schema.text(cutText), false)
                    .scrollIntoView();
                view.dispatch(tr);
                return true;
            },
        },
        appendTransaction: (transactions, oldState, newState) => {
            if (!maxLength)
                return null;
            const currentSize = getDocContentSize(newState);
            if (currentSize > maxLength) {
                const oldSize = getDocContentSize(oldState);
                const addedLength = currentSize - oldSize;
                const oversize = currentSize - maxLength;
                const currentPos = oldState.selection.from;
                return newState.tr.insertText("", currentPos + addedLength - oversize, currentPos + addedLength);
            }
            return null;
        },
    });
}
